// API Configuration File
// Base URL and configuration for all API endpoints
// Set REACT_APP_API_BASE_URL in .env.development / .env.production

export const BASE_URL =  'https://ctmapi.zerlak.com/api/v1';

export const API_ENDPOINTS = {
  // Authentication Endpoints
  AUTH: {
    
    LOGIN: '/auth/login'
  },
  
  // Dashboard Endpoints
  DASHBOARD: {
    GET_DATA: '/challans/getDashboardData'
  },
  
  // Customer Endpoints
  CUSTOMERS: {
    SEARCH: '/customers/search',
    CREATE: '/customers/create',
    GET_BY_ID: (id) => `/customers/getById/${id}`,
    UPDATE: (id) => `/customers/update/${id}`,
    DELETE: (id) => `/customers/${id}`,
    DELETE_BY_ID: (id) => `/customers/deleteById/${id}`,
    VIEW: '/customers/search?page=0&size=9'
  },
  
  // Challan Endpoints
  CHALLANS: {
    GET_ALL: '/challans',
    CREATE: '/challans/create',
    GET_BY_ID: (id) => `/challans/getByChallanId/${id}`,
    UPDATE: (id) => `/challans/updateChallanById/${id}`,
    DELETE: (id) => `/challans/deleteChallanById/${id}`,
    DELETE_BY_ID: (id) => `/challans/deleteChallanById/${id}`,
    DOWNLOAD: (id) => `/challans/download/${id}`,
    FILTER: '/challans/filter',
    SEARCH: '/challans/searchChallans',
    GET_CUSTOMER_INVENTORY: (customerId) => `/challans/getCustomersInventoryItems/${customerId}`,
    UPDATE_COMBINED: (id) => `/challans/combined/${id}`,
    GET_COMBINED: (id) => `/challans/combined/${id}`
  },
  
  // Goods/Cylinder Endpoints
  GOODS: {
    GET_ALL: '/goods/getAllGoods',
    CREATE: '/goods/create',
    UPDATE: (id) => `/goods/${id}`,
    DELETE: (id) => `/goods/${id}`,
    SEARCH: '/goods/search'
  },
  
  // Cylinder Master Endpoints
  CYLINDERS: {
    GET_ALL: '/cylinders',
    CREATE: '/cylinders/create',
    UPDATE: (id) => `/cylinders/${id}`,
    DELETE: (id) => `/cylinders/${id}`,
    SEARCH: '/cylinders/search'
  },
  
  // Purchase Endpoints
  PURCHASE: {
    GET_ALL: '/purchase/getAll',
    GET_BY_ID: (id) => `/purchase/getById/${id}`,
    CREATE: '/purchase/create',
    UPDATE: (id) => `/purchase/update/${id}`,
    DELETE: (id) => `/purchase/delete/${id}`,
    SEARCH: '/purchase/search',
    GET_BY_VENDOR_ID: (vendorId) => `/purchase/getByVendor?vendorId=${vendorId}`,
    GET_VENDOR_PASSBOOK_SUMMARY: (vendorId) => `/purchase/getVendorPassbookSummary?vendorId=${vendorId}`,
    GET_VENDOR_STATEMENT: (vendorId) => `/purchase/statement/vendor/${vendorId}`,
    GET_VENDOR_PRODUCT_STATEMENT: (vendorId, goodsItemId) => `/purchase/statement/vendor/${vendorId}/product/${goodsItemId}`,
    GET_VENDOR_INVENTORY: (vendorId) => `/purchase/vendor/${vendorId}/inventory`,
  },
  
  // Vendor Passbook Endpoints
  VENDOR_PASSBOOK: {
    GET_SUMMARY: (vendorId) => `/purchase/getVendorPassbookSummary?vendorId=${vendorId}`,
    GET_STATEMENT: (vendorId) => `/purchase/statement/vendor/${vendorId}`,
    GET_PRODUCT_STATEMENT: (vendorId, goodsItemId) => `/purchase/statement/vendor/${vendorId}/product/${goodsItemId}`,
    GET_INVENTORY: (vendorId) => `/purchase/vendor/${vendorId}/inventory`,
  },
  
  // Passbook Endpoints
  PASSBOOK: {
    GET_ALL: '/passbook',
    CREATE: '/passbook/create',
    UPDATE: (id) => `/passbook/${id}`,
    DELETE: (id) => `/passbook/${id}`,
    FILTER: '/passbook/filter',
    GET_SUMMARY: (id) => `/challans/getPassbookSummary?id=${id}`,
    GET_PASSBOOK: '/challans/passbook',
    DOWNLOAD_COMPLETE: (customerId) => `/challans/statement/pdf?customerId=${customerId}`,
    DOWNLOAD_PRODUCT: (customerId, itemName) => `/challans/pdf/item?customerId=${customerId}&itemName=${encodeURIComponent(itemName)}`,
    GENERATE_STATEMENT_PDF: '/challans/statement/pdf'
  },
  
  // Profile Endpoints
  PROFILE: {
    GET: '/profiles',
    UPDATE: '/profiles/update',
    CHANGE_PASSWORD: '/profiles/change-password'
  },
  
  // Settings Endpoints
  SETTINGS: {
    GET: '/settings/getSettings',
    UPDATE: '/settings/update'
  },
  
  // User Endpoints
  USERS: {
    GET_ALL: '/settings/users/getAllUsers'
  },
  
  // WhatsApp Credits Endpoints
  WHATSAPP: {
    GET_CREDITS: '/client-config/current/whatsapp-credits'
  },
  
  // Billing Endpoints
  BILLING: {
    MONTHLY_STATUS: '/billing/monthly-status',
    STATEMENT_PDF: (customerId) => `/billing/statement/${customerId}/pdf`,
    BULK_PDF_ZIP: '/billing/bulk-pdf-zip'
  },
  
  // Invoice Endpoints (Recurring Invoices)
  INVOICE: {
    GET_ALL: '/recurring-invoices',
    GET_BY_ID: (id) => `/recurring-invoices/${id}`,
    CREATE: '/recurring-invoices',
    UPDATE: (id) => `/recurring-invoices/${id}`,
    DELETE: (id) => `/recurring-invoices/${id}`,
    GET_DRAFTS: '/recurring-invoices/draft',
    CREATE_DRAFT: '/recurring-invoices/draft'
  },
  
  // Vendor Endpoints
  VENDOR: {
    CREATE: '/vendor/create',
    UPDATE: (id) => `/vendor/update/${id}`,
    DELETE: (id) => `/vendor/delete/${id}`,
    GET_ALL: '/vendor/getAll',
    GET_BY_NAME: '/vendor/getByName',
    GET_BY_ID: (id) => `/vendor/getById/${id}`
  },
  
  // Sales Order Endpoints
  SALES_ORDERS: {
    GET_ALL: '/sales-orders',
    GET_BY_ID: (id) => `/sales-orders/${id}`,
    CREATE: '/sales-orders',
    UPDATE: (id) => `/sales-orders/${id}`,
    DELETE: (id) => `/sales-orders/${id}`,
    CONFIRM: (id) => `/sales-orders/${id}/confirm`,
    MARK_PAID: (id) => `/sales-orders/${id}/pay`,
    STATS: '/sales-orders/stats'
  },
  
  // Estimate Endpoints
  ESTIMATES: {
    GET_ALL: '/estimates',
    GET_BY_ID: (id) => `/estimates/${id}`,
    CREATE: '/estimates',
    UPDATE: (id) => `/estimates/${id}`,
    DELETE: (id) => `/estimates/${id}`,
    NEXT_NUMBER: '/estimates/next-number',
    STATISTICS: '/estimates/statistics',
    CONVERT: (id) => `/estimates/${id}/convert`,
    SEND: (id) => `/estimates/${id}/send`
  },
  
  // Bill Endpoints
  BILL: {
    GET_ALL: '/bill',
    GET_BY_ID: (id) => `/bill/${id}`,
    CREATE: '/bill/create',
    UPDATE: (id) => `/bill/${id}`,
    DELETE: (id) => `/bill/${id}`,
    SEARCH: '/bill/search',
    SAVE_DRAFT: '/bill/saveDraft',
    GET_DRAFTS: '/bill/getDrafts',
    GET_DRAFT_BY_ID: (id) => `/bill/getDraft/${id}`
  },
  
  // Payment Endpoints
  PAYMENTS: {
    GET_ALL: '/payments',
    GET_BY_ID: (id) => `/payments/${id}`,
    CREATE: '/payments',
    UPDATE: (id) => `/payments/${id}`,
    DELETE: (id) => `/payments/${id}`
  },
  
  // Credit Note Endpoints (TODO: Backend needs to be created)
  CREDIT_NOTES: {
    GET_ALL: '/credit-notes',
    GET_BY_ID: (id) => `/credit-notes/${id}`,
    CREATE: '/credit-notes',
    UPDATE: (id) => `/credit-notes/${id}`,
    DELETE: (id) => `/credit-notes/${id}`,
    STATS: '/credit-notes/stats'
  },
  
  // Debit Note Endpoints (TODO: Backend needs to be created)
  DEBIT_NOTES: {
    GET_ALL: '/debit-notes',
    GET_BY_ID: (id) => `/debit-notes/${id}`,
    CREATE: '/debit-notes',
    UPDATE: (id) => `/debit-notes/${id}`,
    DELETE: (id) => `/debit-notes/${id}`,
    STATS: '/debit-notes/stats'
  }
};

const config = { BASE_URL, API_ENDPOINTS };
export default config;
